export default "__VITE_ASSET__BXu1iIj$__"